import images from "./images";

const About = {
    sub: "About Us",
    heading: "Dedicated to Fire Safety and Emergency Response",
    description: [
        "At FireGuard, we have been serving our community for two decades with a commitment to ensuring fire safety and swift emergency response. Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum voluptatibus dolores."
    ],
    experience: {
        year: 20,
        text: 'years of experience',
    },
    points: [
        "Rapid Emergency Response Services",
        "Community Fire Safety Education",
        "State-of-the-Art Firefighting Equipment",
        "24/7 Fire Department Support",
    ],
    image: {
        src1: images.about1,
        src2: images.about2,
        src3: images.about3,
        src4: images.about4,
        alt1: "About-Image1",
        alt2: "About-Image2",
        alt3: "About-Image3",
        alt4: "About-Image4",
    },
    button: {
        text: "Contact Us",
        link: "Contact-us"
    }
};

export default About;